// extracted by mini-css-extract-plugin
module.exports = {"container":"PhoneMaskInput_container__NjTmm","error":"PhoneMaskInput_error__3GS62"};